import { Typography } from '@mui/material';
import Pagination from '@mui/material/Pagination';
import { FC, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import './Pagination.scss';
import { ListMeta } from '@interfaces/apis/response-data';

interface PaginationProps {
  meta?: ListMeta;
  onChange?: (page: string) => void;
}

const AppPagination: FC<PaginationProps> = ({ meta, onChange }) => {
  const { t } = useTranslation();

  const handleChangePage = useCallback(
    (_: React.ChangeEvent<unknown>, page: number) => {
      if (page !== meta?.page) {
        onChange?.(String(page));
      }
    },
    [meta]
  );

  return (
    <div className='Pagination'>
      <div className='Pagination__wrapper'>
        {!!meta?.pagination?.total && (
          <Typography>
            {t('common.display_pagination', {
              0: meta?.pagination?.total,
              1: (meta?.pagination?.page - 1) * meta?.pagination?.pageSize + 1,
              2:
                meta?.pagination?.page * meta?.pagination?.pageSize <
                meta?.pagination?.total
                  ? meta?.pagination?.page * meta?.pagination?.pageSize
                  : meta?.pagination?.total,
            })}
          </Typography>
        )}
        <Pagination
          page={meta?.pagination?.page ?? 1}
          count={
            meta?.pagination
              ? Math.ceil(meta?.pagination?.total / meta?.pagination?.pageSize)
              : 0
          }
          variant='outlined'
          shape='rounded'
          onChange={handleChangePage}
        />
      </div>
    </div>
  );
};

export default AppPagination;
